import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import { IAction } from '~/src/store';

import { ECrediteActions } from './actionTypes';

export const setSelectedCreditCondition = (creditCondition: ICreditCondition): IAction<ECrediteActions.SetSelectedCreditCondition, ICreditCondition> => ({
    type: ECrediteActions.SetSelectedCreditCondition,
    payload: creditCondition,
});
